import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 缓存原型上的push函数
const originPush = Router.prototype.push
const originReplace = Router.prototype.replace
// 给原型对象上的push指定新函数函数
Router.prototype.push = function (location, onComplete, onAbort) {
  // 判断如果没有指定回调函数, 通过call调用源函数并使用catch来处理错误
  if (onComplete===undefined && onAbort===undefined) {
    return originPush.call(this, location, onComplete, onAbort).catch(() => {})
  } else { // 如果有指定任意回调函数, 通过call调用源push函数处理
    originPush.call(this, location, onComplete, onAbort)
  }
}
// replace同理处理
Router.prototype.replace = function (location, onComplete, onAbort) {
  if (onComplete===undefined && onAbort===undefined) {
    return originReplace.call(this, location, onComplete, onAbort).catch(() => {})
  } else {
    originReplace.call(this, location, onComplete, onAbort)
  }
}

let mode = 'hash'
if (process.env.NODE_ENV === 'ssr') {
  mode = 'history'
}
const router = new Router({
  mode: mode,
  // 带有keepAlive缓存组件记住滚动条位置
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop
      }
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  },
  routes: [
    {
      path: '/index',
      name: 'index',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "bindCard" */ '@/views/index.vue')
    },
    {
      path: '/bindCard',
      name: 'bindCard',
      meta: {
        title: '',
        level: 2
      },
      component: () =>
        import(/* webpackChunkName: "bindCard" */ '@/views/bindCard.vue')
    },
    {
      path: '/bindCardResult',
      name: 'bindCardResult',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "bindCard" */ '@/views/bindCardResult.vue')
    },
    {
      path: '/bindCardNotice',
      name: 'bindCardNotice',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "bindCard" */ '@/views/bindCardNotice.vue')
    },
    {
      path: '/bindCardWaiting',
      name: 'bindCardWaiting',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "bindCard" */ '@/views/bindCardWaiting.vue')
    },
    {
      path: '/checkCode',
      name: 'checkCode',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "bindCard" */ '@/views/checkCode.vue')
    },
    {
      path: '/checkPin',
      name: 'checkPin',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "bindCard" */ '@/views/checkPin.vue')
    },
    {
      path: '/checkPhone',
      name: 'checkPhone',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "bindCard" */ '@/views/checkPhone.vue')
    },
    {
      path: '/checkBirth',
      name: 'checkBirth',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "bindCard" */ '@/views/checkBirth.vue')
    },
    {
      path: '/addCard',
      name: 'addCard',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "bindCard" */ '@/views/addCard.vue')
    },
    {
      path: '/thirdBankAuth',
      name: 'thirdBankAuth',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "bindCard" */ '@/views/thirdBankAuth.vue')
    },
    {
      path: '/bindAccount',
      name: 'bindAccount',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "bindAccount" */ '@/views/bindAccount.vue')
    },
    {
      path: '/bindAccountResult',
      name: 'bindAccountResult',
      meta: {
        title: ''
      },
      component: () =>
        import(
          /* webpackChunkName: "bindAccount" */ '@/views/bindAccountResult.vue'
        )
    },
    {
      path: '/contract',
      name: 'contract',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "bindAccount" */ '@/views/contract.vue')
    },
    {
      path: '/payResult',
      name: 'payResult',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "payment" */ '@/views/payResult.vue')
    },
    {
      path: '/addAccount',
      name: 'addAccount',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "payment" */ '@/views/addAccount.vue')
    },
    {
      path: '/payMethod',
      name: 'payMethod',
      meta: {
        title: '',
        level: 1
      },
      component: () =>
        import(/* webpackChunkName: "payment" */ '@/views/payMethod.vue')
    },
    {
      path: '/virtualAccount',
      name: 'virtualAccount',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "payment" */ '@/views/virtualAccount.vue')
    },
    {
      path: '/thirdLink',
      name: 'thirdLink',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "payment" */ '@/views/thirdLink.vue')
    },
    /********************************************  绑账户页面 start **********************************/
    {
      path: '/addBankAccount',
      name: 'addBankAccount',
      meta: {
        title: '',
        level: 3
      },
      component: () =>
        import(/* webpackChunkName: "payment" */ '@/views/addBankAccount/addBankAccount.vue')
    },
    // 转50N
    {
      path: '/addBankAccountResult',
      name: 'addBankAccountResult',
      meta: {
        title: ''
      },
      component: () =>
        import(
          /* webpackChunkName: "payment" */ '@/views/addBankAccount/addBankAccountResult.vue'
        )
    },
    {
      path: '/addBankAccountQueryResult',
      name: 'addBankAccountQueryResult',
      meta: {
        title: ''
      },
      component: () =>
        import(
          /* webpackChunkName: "payment" */ '@/views/addBankAccount/addBankAccountQueryResult.vue'
        )
    },
    // 绑账户结果页，包含了三个步骤的新页面
    {
      path: '/addBankAccountResultSteps',
      name: 'addBankAccountResultSteps',
      meta: {
        title: ''
      },
      component: () =>
        import(
          /* webpackChunkName: "payment" */ '@/views/addBankAccount/addBankAccountResultSteps.vue'
        )
    },
    /********************************************  绑账户页面 end **********************************/

    // 在绑账户提交后，判断如果是goldman的账户，不再调用NIBSS接口，而是调用goldman接口去请求OTP
    {
      path: '/verifyOtp',
      name: 'verifyOtp',
      meta: {
        title: ''
      },
      component: () =>
        import(
          /* webpackChunkName: "payment" */ '@/views/goldman/verifyOtp.vue'
        )
    },
    {
      path: '/viewAgreement',
      name: 'viewAgreement',
      meta: {
        title: ''
      },
      component: () =>
        import(
          /* webpackChunkName: "payment" */ '@/views/goldman/viewAgreement.vue'
        )
    },
    // 监控页面，用于监控前端服务发布异常
    {
      path: '/healthMonitorCheck',
      name: 'healthMonitorCheck',
      meta: {
        title: ''
      },
      component: () =>
        import(
          /* webpackChunkName: "payment" */ '@/views/healthMonitorCheck.vue'
        )
    },
    {
      path: '/tempPayMethod',
      name: 'tempPayMethod',
      meta: {
        title: ''
      },
      component: () =>
        import(/* webpackChunkName: "tempPayMethod" */ '@/template/payMethod.vue')
    },

    // 新的绑卡，绑账户tabs  
    {
      path: '/bankCardTabs',
      name: 'bankCardTabs',
      meta: {
        title: '',
        level: 2
      },
      component: () =>
        import(/* webpackChunkName: "bindCard" */ '@/views/account/bankCardTabs.vue')
    }
  ]
})

export default router
